import React, { useState } from "react";
import "../../styles/ContactForm.css";

interface ContactFormProps {
  contactEmail: string;
}
const activeTopics = [
  "Website or app development",
  "Immersive XR experience",
  "AI-assisted creative workflow",
  "AlluraXR",
  "Music & Story Lab",
  "Free Video Starter",
  "AlluraPath Finland",
  "Helsinki Dev Jobs",
  "Student Opportunity Radar",
  "Partnership or general question",
];

const ContactForm: React.FC<ContactFormProps> = ({ contactEmail }) => {
  const initialTopic = new URLSearchParams(window.location.search).get("service") || "";
  const [topic, setTopic] = useState(activeTopics.includes(initialTopic) ? initialTopic : "");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  const prepareEmail = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const subject = `AlluraTech inquiry: ${topic}`;
    const body = [`Name: ${name}`, `Email: ${email}`, `Topic: ${topic}`, "", message].join("\n");
    setStatus("Your email app will open with this message. Please review and send it there.");
    window.location.href = `mailto:${contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <form className="contact-form" id="service-request-form" onSubmit={prepareEmail}>
      <div className="contact-form-heading">
        <h2>Tell us what you have in mind</h2>
        <p>Share a few details and we will help you find the right starting point.</p>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="contact-name">Your name</label>
          <input id="contact-name" type="text" value={name} onChange={(event) => setName(event.target.value)} autoComplete="name" placeholder="Your name" required />
        </div>
        <div className="form-group">
          <label htmlFor="contact-email">Your email</label>
          <input id="contact-email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" placeholder="you@example.com" required />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="contact-topic">What can we help with?</label>
        <select id="contact-topic" value={topic} onChange={(event) => setTopic(event.target.value)} required>
          <option value="">Choose a topic</option>
          {activeTopics.map((item) => <option key={item} value={item}>{item}</option>)}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="contact-message">Your message</label>
        <textarea id="contact-message" value={message} onChange={(event) => setMessage(event.target.value)} placeholder="Tell us about your question, project or idea" rows={6} required />
      </div>
      <button className="submit-btn" type="submit">Prepare email <span aria-hidden="true">↗</span></button>
      <p className="contact-form-note">This opens a draft in your email app. Please review and send it from there.</p>
      <p className="form-status" role="status" aria-live="polite">{status || <>Prefer to write directly? <a href={`mailto:${contactEmail}`}>{contactEmail}</a></>}</p>
    </form>
  );
};

export default ContactForm;
